import React, {useMemo, useRef, useState} from 'react';
import dayjs from "dayjs";
import TablePage from "../../pages/tablePage/TablePage";
import NoticeEditModal from "./NoticeEditModal";

const Notice = () => {
    const [rowData, setRowData] = useState({});
    const refreshRef = useRef(null);

    const columns = useMemo(() => ([
        {
            title: 'ID',
            dataIndex: 'seq',
            key: 'seq',
        },
        {
            title: '파일 이름',
            dataIndex: 'fileName',
            search: true,
        },
        {
            title: '메모',
            dataIndex: 'memo',
        },
        {
            title: '생성일',
            dataIndex: 'created',
            render: (created) => dayjs(created).format('YYYY-MM-DD HH:mm:ss'),
        },
    ]), []);

    const props = {
        columns,
        rowData,
        setRowData,
        modal: NoticeEditModal,
        refreshRef,
        url: 'banner/notice',
        buttonText: '신규 공지 추가',
    }

    return (
        <TablePage {...props} />
    );
};

export default Notice;